import { FREE_PLAN_INVOICES_LIMIT_PER_MONTH } from 'shared/constants/invoices/limits';

import { useInvoicingSystemContext } from '@/context/InvoicingSystemContext';
import { useSubscriptionContext } from '@/context/SubscriptionContext';

export const useMonthlyInvoicesLimit = (monthlyInvoicesCount: number) => {
    const { isInvoiceCapEnabled } = useInvoicingSystemContext();
    const { isCurrentSubscriptionActive } = useSubscriptionContext();

    const isInvoiceCapApplied =
        isInvoiceCapEnabled && !isCurrentSubscriptionActive;

    return {
        isInvoiceCapApplied,
        isInvoiceLimitReached:
            isInvoiceCapApplied &&
            monthlyInvoicesCount >= FREE_PLAN_INVOICES_LIMIT_PER_MONTH,
    };
};
